var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_core.js
// module id = 12
// module chunks = 0